// extracted by mini-css-extract-plugin
export default {"container":"Bio_container__6FRmh"};